<template>
  <div class="page-with-top-bar h-full">
    <viewer-page-design ref="refViewerPageDesign"
          :is-loading="isLoading"
          :pictograms="pictograms"
          :entity-id="projectId"
          :can-actions-pictogram="canActionsPictogram"
          @epc-in-design-mode="(e) => { designMode = e }"
          @epc-photovoltaic-park-loaded="(e) => { partsPark = e }"
          @epc-pictogram-project-dataset="(e) => { datasetProject = e }"
          @epc-pictogram-data-progress="(e) => { progressPictogram = e }"/>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import axios from "axios";
  import ViewerPageDesign from '../../components/pictograms/solar-park/views/ViewerPageDesign.vue';


  export default {
    middleware: "auth",
    title: "power_plant_drawings_page_title",

    components: {
      ViewerPageDesign
    },

    computed: {
      ...mapGetters({
        navData: "app/navData",
        user: "auth/user",
      }),

      projectId() {
        return parseInt(this.navData.project_id);
      }
    },

    data: () => ({
      isLoading: false,
      pictograms: [],
      canActionsPictogram: {
        'mode_dashboard': false,
        'show_header': true,
        'save': true,
        'select_entity': false,
        'show_side_panel': false,   // admin: solo diseño, sin panel lateral ni su botón
        'view_interactions': false  // admin: sin hover/doble-click/click de vista
      }
    }),

    watch: {
      mainActiveTab(value) {
        if (value == 1) {
          this.$refs.refManagePhotovoltaicPark.FullScreenHack()
        }
      }
    },

    created() {
      let projectName = this.navData.project_name
        ? this.navData.project_name.toUpperCase()
        : "";
      this.$options.subtitle = ["project_actions_page_subtitle", [projectName]];

      this.entityId = this.projectId;

      this.getProjectPictograms();
    },

    mounted() {

    },

    beforeDestroy(){
    },

    methods: {
      async getProjectPictograms() {
        this.isLoading = true;
        let params = { };

        const { data } = await axios.get(
          "/api/v2/project/" + this.entityId + "/pictograms",
          { params: params }
        );

        if (data && data.success) {
          this.pictograms = data.pictograms;
          this.total = data.pictograms ? data.pictograms.length : 0;
        } else {
          this.$notify.error("error_loading_documents");
        }
        this.isLoading = false;
      },

      _HandlePictogramsRefresh() {
        this.$refs.refManagePictograms.RefreshListPictograms()
        this.mainActiveTab = 0
      }
    }
  };
</script>
